module.exports = "pegasus/assets/theme5/small/4.jpg";